module.exports = __webpack_public_path__ + "img/primary.9918b92.svg";